import React from 'react';
import { Card, CardMedia, CardContent, CardActions, Typography, Button } from '@mui/material'

interface WhoCardPropos {
  name: string;
  role: string;
  email: string;
  image?: string;
  imageTitle?: string;
  imageProps?: string;
}

const WhoCard = (props: WhoCardPropos) => {

  const { name, role, email, image, imageTitle, imageProps } = props;

  return (<Card sx={{ width: 250, marginTop: 2 }}>
    <CardMedia
      sx={{ height: 300 }}
      image={image}
      title={imageTitle}
    />
    <CardContent>
      <Typography gutterBottom variant="h5" component="div">
        {name}
      </Typography>
      {role && (<Typography variant="body1" color="text.secondary">
        {role}
      </Typography>)}
      {email && (<Typography variant="caption" color="text.secondary">
        {email}
      </Typography>)}

    </CardContent>
  </Card>);

};

export default WhoCard;